import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import "./Dashboard.css";
import profile from "../assets/images/profile.png";
import banner from "../assets/images/banner.png";
import fundamentals from "../assets/images/fundamentals-icon.png";
import email from "../assets/images/email-icon.png";
import malware from "../assets/images/malware-icon.png";
import passsec from "../assets/images/passwordsec-icon.png";
import eksterni from "../assets/images/eksterni-medij-icon.png";
import mobilni from "../assets/images/mobilni-uredjaj-icon.png";
import internet from "../assets/images/koristenje-interneta-icon.png";
import social from "../assets/images/drustvene-mreze-icon.png";
import sigurnost from "../assets/images/sigurnost-kontrola-icon.png";
import wifi from "../assets/images/koristenjewifi-icon.png";
import stol from "../assets/images/pravilo-cistog-stola-icon.png";
import privatnost from "../assets/images/koristenje-podataka-icon.png";
import uredjaji from "../assets/images/koristenje-licnih-uredjaja-icon.png";
import lokacija from "../assets/images/rad-sa-lokacije-icon.png";
import expert from "../assets/images/expert-level-icon.png";


const Dashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ first_name: "", last_name: "", username: "", score: 0, rank: 4, completion: "10%", days: 0 });
  const rawUserId = localStorage.getItem("userId");
  const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;
  console.log("Dohvaćeni userId:", userId);

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token nije pronađen, preusmjeravanje na login...");
        navigate("/login");
        return;
      }

      try {
        const response = await API.get("/user/userD"); // Ispravljena ruta
        const data = response.data?.data?.[0];

        if (!data) {
          console.error("Greška: Nema podataka o korisniku");
          return;
        }

        setUserData((prevData) => ({
          ...prevData,
          first_name: data?.first_name || "N/A",
          last_name: data?.last_name || "N/A",
          username: data?.username || "N/A",
          rank: data?.rank || 4,
          completion: data?.completion || "10%",
        }));
      } catch (error) {
        console.error("Greška pri dohvaćanju korisničkih podataka:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchUserScore = async () => {
      if (!userId) {
        console.error("Greška: userId je null ili nije postavljen.");
        return;
      }
      try {
        const scoreResponse = await API.get(`/module/score/${userId}`);
        const userScore = scoreResponse.data[0]?.score || 0;

        setUserData((prevData) => ({
          ...prevData,
          score: userScore,
        }));
      } catch (error) {
        console.error("Greška pri dohvaćanju score-a:", error);
      }
    };

    if (userId) {
      fetchUserScore();
    }
  }, [userId]);

  useEffect(() => {
    const startDate = new Date("2025-12-12"); // Postavi početni datum
    const currentDate = new Date(); // Trenutni datum

    // Izračunaj razliku u danima samo jednom prilikom mountanja komponente
    const timeDifference = startDate - currentDate; // Razlika u milisekundama
    const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24)); // Pretvori u dane

    setUserData((prevData) => ({
      ...prevData,
      days: daysRemaining, // Postavi preostale dane
    }));
  }, []); // Ovaj useEffect se pokreće samo pri mountanju komponente

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const modules = [
    { title: "Cyber Awareness Intro", xp: 150, image: fundamentals },
    { title: "Email prevare", xp: 300, image: email },
    { title: "Malware", xp: 250, image: malware },
    { title: "Password Security", xp: 300, image: passsec },
    { title: "Eksterni mediji", xp: 250, image: eksterni },
    { title: "Mobilni uređaji", xp: 250, image: mobilni },
    { title: "Korištenje interneta", xp: 250, image: internet },
    { title: "Društvene mreže", xp: 250, image: social },
    { title: "Sigurnost i kontrola pristupa", xp: 250, image: sigurnost },
    { title: "Korištenje WiFi", xp: 250, image: wifi },
    { title: "Pravilo čistog stola", xp: 250, image: stol },
    { title: "Korištenje podataka/privatnost", xp: 250, image: privatnost },
    { title: "Korištenje ličnih uređaja", xp: 250, image: uredjaji },
    { title: "Rad sa udaljene lokacije", xp: 250, image: lokacija },
    { title: "Ekspert level", xp: 450, image: expert },
  ];

  return (
    <div className="dashboard-container">
      <div className="main-content">
        <div className="header-banner">
          <img src={banner} alt="Banner" className="banner-img" />
        </div>

        <h3>Training Modules</h3>

        <div className="modules-grid">
          {modules.map((module, index) => (
            <div
              key={index}
              className="module-card"
              onClick={() => {
                if (module.title === "Email prevare") {
                  navigate("/email-prevare-intro");
                }
                if (module.title === "Malware") {
                  navigate("/malware-intro");
                }
                if (module.title === "Password Security") {
                  navigate("/password-security-intro");
                }

                if (module.title === "Cyber Awareness Intro") {
                  navigate("/intro-dash");
                }
                if (module.title === "Eksterni mediji") {
                  navigate("/eksterni-mediji-intro");
                }
                if (module.title === "Mobilni uređaji") {
                  navigate("/mobilni-uredjaji-intro");
                }
                if (module.title === "Korištenje interneta") {
                  navigate("/koristenje-interneta-intro");
                }
                if (module.title === "Društvene mreže") {
                  navigate("/social-networks-intro");
                }
                if (module.title === "Sigurnost i kontrola pristupa") {
                  navigate("/sigurnost-kontrola-intro");
                }
                if (module.title === "Korištenje WiFi") {
                  navigate("/koristenje-wifi-intro");
                }
                if (module.title === "Pravilo čistog stola") {
                  navigate("/pravilo-cistog-stola-intro");
                }
                if (module.title === "Korištenje podataka/privatnost") {
                  navigate("/koristenje-podataka-intro");
                }
                if (module.title === "Korištenje ličnih uređaja") {
                  navigate("/koristenje-uredjaja-intro");
                }
                if (module.title === "Rad sa udaljene lokacije") {
                  navigate("/udaljena-lokacija-intro");
                }
                if (module.title === "Ekspert level") {
                  navigate("/ekspert-level-intro");
                }
              }}
              style={
                module.title === "Email prevare" ||
                  module.title === "Malware" ||
                  module.title === "Password Security" ||
                  module.title === "Cyber Awareness Intro" ||
                  module.title === "Eksterni mediji" ||
                  module.title === "Mobilni uređaji" ||
                  module.title === "Korištenje interneta" ||
                  module.title === "Društvene mreže" ||
                  module.title === "Sigurnost i kontrola pristupa" ||
                  module.title === "Korištenje WiFi" ||
                  module.title === "Pravilo čistog stola" ||
                  module.title === "Korištenje podataka/privatnost" ||
                  module.title === "Korištenje ličnih uređaja" ||
                  module.title === "Rad sa udaljene lokacije" ||
                  module.title === "Ekspert level"
                  ? { cursor: "pointer" }
                  : {}
              }
            >
              <div className="module-card-content">
                <img src={module.image} alt={module.title} className="module-image" />
                <h4>{module.title}</h4>
                <p>{module.xp} XP</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar">
        <div className="profile">
          <img src={profile} alt="Profile" className="profile-img" />
          <h4>{userData.first_name} {userData.last_name}</h4>
          <p>@{userData.username}</p>
        </div>
        <div className="profile-info">
          <div className="profile-info-header">
            <h4>Profile Info</h4>
            <p
              className="see-all"
              onClick={() => navigate("/user-profile")}
            >
              See All
            </p>
          </div>
          <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
          <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
          <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
          <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
        </div>
        <div className="logout-container">
          <button onClick={handleLogout} className="logout-btn">Log out</button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;